import { FC } from 'react'
import { Spacer, TextSkeleton, VStack } from '@revolut-internal/ui-kit'

import { ChatInputLoading } from '../ChatInput'
import { ChatMessagesListLoading } from '../ChatMessagesList'

export const AssistantPlaygroundContentLoading: FC = () => {
  return (
    <VStack align="center" height="100%" gap="s-32">
      <Spacer />
      <ChatMessagesListLoading />
      <VStack align="center" gap="s-16">
        <ChatInputLoading />
        <TextSkeleton width={400} />
      </VStack>
    </VStack>
  )
}
